import { selectionsData } from "@/data";
import { SET_SELECTION, SET_SELECTION_LOADING } from "@/redux/types";
import { updateStateHandler } from "@/utils";

const {
    artworkFileNames,
    distributionTypes,
    editDistributionTypes,
    fileTypes,
    folderNames,
    mimeTypes,
    motionArtworkTypes,
    trackContributors,
    trackFileNames,
    trackFormats,
    xmlFileNames,
} = selectionsData.data;

const initialState = {
    artworkFileNames,
    distributionTypes,
    editDistributionTypes,
    fileTypes,
    folderNames,
    hasLoaded: false,
    mimeTypes,
    motionArtworkTypes,
    trackContributors,
    trackFileNames,
    trackFormats,
    xmlFileNames,
};

const setSelection = (state, selection) => updateStateHandler(state, selection);

const setSelectionLoading = (state, key, isLoading) => ({
    ...state,
    hasLoaded: {
        ...state.hasLoaded,
        [key]: !isLoading,
    },
});

const selectionsReducer = (state = initialState, action) => {
    const { payload, type } = action;

    const { isLoading, key, selection } = payload || {};

    switch (type) {
        case SET_SELECTION:
            return setSelection(state, selection);
        case SET_SELECTION_LOADING:
            return setSelectionLoading(state, key, isLoading);
        default:
            return state;
    }
};

export default selectionsReducer;
